const useSkills = () => {
    const skills = {
        'analysis': {
            'team': ['Prudence', 'Méditation'],
            'enemy': ['Embrouilles']
        },
        'communication': {
            'team': ['Parlotte', 'Mégaphone'],
            'enemy': ['Son Strident', 'Voix Enjôleuse', 'Voix Envoûtante', 'Nouvelles demandes via vidéo WhatsApp', 'Brouhaha']
        },
        'design': {
            'team': ['Gribouillage', 'Multitude d\'onglets'],
            'enemy': ['Logo plus gros', 'Couleur Versatile', '2px à gauche', 'Plus d\'espace', 'Alignement Incorrect', 'Pinaillage']
        },
        'development': {
            'team': ['Stack Overflow', 'ChatGPT', 'Gemini', 'Méthode du Canard en plastique'],
            'enemy': ['Bug Urgent', 'Demande Impromptue', 'Demandes Intempestives', 'Bug non défini', 'Erreur 418']
        },
        'documentation': {
            'team': ['Scribouillard', 'Gratte-papier'],
            'enemy': ['Indéchiffrable', 'Hiéroglyphe', 'Charabia']
        },
        'maintenance': {
            'team': [],
            'enemy': ['Modification de texte inintéressant']
        },
        'management': {
            'team': ['Vision Stratégique', 'Feedback Fulgurant', 'Coaching'],
            'enemy': ['Deadline Fantôme']
        },
        'meeting': {
            'team': ['Repos', 'Ronflement', 'Migraine', 'Bâillement'],
            'enemy': ['Berceuse', 'Hypnose', 'Supplice']
        },
        'office': {
            'team': ['Recyclage', 'Grand Nettoyage'],
            'enemy': ['Appel Surprise']
        },
        'other': {
            'team': ['Pause Café', 'Multitâche', 'Puissance Cachée'],
            'enemy': ['Tout ou Rien']
        },
        'prospection': {
            'team': ['Ruée vers l\'or', 'Jackpot'],
            'enemy': ['Refus Catégorique']
        },
        'r&d': {
            'team': ['Tuto', 'Éclaireur'],
            'enemy': ['Champ de mines']
        },
        'support': {
            'team': ['Reboot Magique', 'Assistance'],
            'enemy': ['Pression Extrême', 'Prise Débranchée']
        },
        'testing': {
            'team': ['Couverture'],
            'enemy': ['BSoD', 'Boucle Infernale']
        },
        'training': {
            'team': ['Apprentissage Rapide'],
            'enemy': []
        },
        'veille': {
            'team': [],
            'enemy': ['Article Hypnotique']
        }
    };

    const getSkill = (type, category) => {
        const array = skills[type?.toLowerCase()] ? skills[type?.toLowerCase()][category] : [];
        if (array?.length > 0) {
            return array[Math.floor(Math.random() * array.length)];
        }
        return 'Charge';
    };

    return {
        values: skills,
        getSkill
    };
};

export default useSkills;